const dialog = {
    confirmDialog(message, scriptConfirmBtn) {
        return this.$swal({
            title: "Are you sure?",
            text: message,
            icon: "warning",
            showCancelButton: true,
            // confirmButtonText: "Yes, delete it!",
            confirmButtonText: `Yes, ${scriptConfirmBtn}!`,
            cancelButtonText: "Cancel",
            reverseButtons: true,
            customClass: {
                confirmButton: "btn bg-gradient-success",
                cancelButton: "btn bg-gradient-danger",
            },
            buttonsStyling: false,
        })
    },
    // Diperuntukan untuk konfirmasi cancel/duplicate item, dengan opsi input textarea untuk alasan.
    // isAlreadyCanceled = true (dimaksud item sudah berstatus 'canceled'/'duplicate' sebelumnya, reason tidak wajib) sedangkan isAlreadyCanceled = false (dimaksud item belum berstatus tersebut, reason wajib diisi).
    // type = 'cancel' | 'duplicate'
    // showInputOverride = paksa tampil/sembunyikan textarea, lepas dari nilai isAlreadyCanceled (default: !isAlreadyCanceled).
    confirmCancelItemDialog(isAlreadyCanceled, type, customText, showInputOverride) {
        const isDuplicate = type === 'duplicate';
        const text = customText || (isDuplicate ? (isAlreadyCanceled ? "This item will be unmarked as a duplicate." : "This item will be marked as a duplicate.") : (isAlreadyCanceled ? "This item will be uncanceled." : "This item will be canceled."));
        const confirmButtonText = isDuplicate ? (isAlreadyCanceled ? "Yes, unmark it!" : "Yes, mark it!") : (isAlreadyCanceled ? "Yes, uncancel it!" : "Yes, cancel it!");

        const options = {
            title: "Are you sure?",
            text,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText,
            cancelButtonText: "Close",
            reverseButtons: true,
            customClass: {
                confirmButton: "btn bg-gradient-success",
                cancelButton: "btn bg-gradient-danger",
            },
            buttonsStyling: false,
        };

        const showInput = showInputOverride !== undefined ? showInputOverride : !isAlreadyCanceled;
        if (showInput) {
            options.input = "textarea";
            options.inputPlaceholder = isDuplicate && !isAlreadyCanceled ? "Enter the reason for marking as duplicate..." : "Enter the reason for cancellation...";
            options.inputValidator = (value) => {
                if (!value || !value.trim()) {
                    return "Reason is required";
                }
            };
        }

        return this.$swal(options);
    },
    // Konfirmasi sebelum start approval MCR (UserForm) kalau ada manufacturer duplikat terdeteksi.
    // duplicatedRows = array nomor baris (1-based) MCR item yang terdeteksi duplikat.
    confirmDuplicateManufInUserForm(duplicatedRows) {
        const joinWithAnd = (nums) => {
            if (nums.length === 1) return `${nums[0]}`;
            if (nums.length === 2) return `${nums[0]} and ${nums[1]}`;
            return `${nums.slice(0, -1).join(', ')}, and ${nums[nums.length - 1]}`;
        };

        return this.$swal({
            icon: "warning",
            title: "Are you sure?",
            text: `Duplicate manufacturer detected in MCR items ${joinWithAnd(duplicatedRows)}. Would you like to proceed the Start, or should these MCR items be corrected first?`,
            showCancelButton: true,
            confirmButtonText: "Yes, start the Approval",
            cancelButtonText: "No, correct it first!",
            reverseButtons: true,
            customClass: {
                confirmButton: "btn bg-gradient-success",
                cancelButton: "btn bg-gradient-danger",
            },
            buttonsStyling: false,
        });
    },
    // Dialog single-select (dropdown). 
    // Dipakai untuk berbagai keperluan pilih-satu-opsi (mis. pilih User TIMAH Technical Reviewer untuk next step)
    selectOptionDialog({ title, inputOptions, inputPlaceholder, confirmButtonText = "Confirm", cancelButtonText = "Cancel", inputValidator }) {
        return this.$swal({
            title,
            input: "select",
            inputOptions,
            inputPlaceholder,
            showCancelButton: true,
            confirmButtonText,
            cancelButtonText,
            reverseButtons: true,
            customClass: {
                confirmButton: "btn bg-gradient-success",
                cancelButton: "btn bg-gradient-danger",
            },
            buttonsStyling: false,
            inputValidator,
        });
    },
}

export default dialog